import { Box } from "@material-ui/core";
import React from "react";

import WeeklyEACODCFixedTable from "./WeeklyEACODCFixedTable";
import WeeklyEACODCWeeklyTable from "./WeeklyEACODCWeeklyTable";
import WeeklyEACODCTotalsTable from "./WeeklyEACODCTotalsTable";
import { getWeekColumns } from "./weeklyEACCalculations";
import { ODC_FIXED_TOTAL_WIDTH } from "./weeklyEACODCColumns";

const noDataStyle = {
  textAlign: "center",
  fontWeight: 600,
  background: "#fff",
  padding: "24px 0",
};

// Sits between Direct Labor and Summary. Editing (Unburden Cost only) shares Direct Labor's own
// Edit/Save/Cancel controls rather than duplicating them here — isEdit is just passed through.
export default function WeeklyEACODCTable({
  odcDetails,
  allOdcDetails,
  type,
  isEdit,
  onUnburdenCostChange,
  scrollRef,
  onScroll,
}) {
  const weekColumns = getWeekColumns(allOdcDetails);

  return (
    <Box style={{ marginTop: "16px" }}>
      <div
        style={{
          width: "220px",
          height: "36px",
          padding: "0 0 0 12px",
          fontSize: "15px",
          color: "#ffffff",
          backgroundColor: "#000",
          borderRadius: "0 10px 0 0",
          display: "flex",
          alignItems: "center",
        }}
      >
        Other Direct Costs
      </div>
      {odcDetails.length === 0 ? (
        <div style={noDataStyle}>No Data</div>
      ) : (
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: ODC_FIXED_TOTAL_WIDTH,
              marginRight: "8px",
            }}
          >
            <WeeklyEACODCFixedTable odcDetails={odcDetails} />
          </Box>
          <Box
            ref={scrollRef}
            onScroll={onScroll}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          >
            <Box display="flex" flexDirection="row">
              <Box style={{ marginRight: "8px" }}>
                <WeeklyEACODCWeeklyTable
                  odcDetails={odcDetails}
                  allOdcDetails={allOdcDetails}
                  weekColumns={weekColumns}
                  type={type}
                  isEdit={isEdit}
                  onUnburdenCostChange={onUnburdenCostChange}
                />
              </Box>
              <Box>
                <WeeklyEACODCTotalsTable odcDetails={odcDetails} allOdcDetails={allOdcDetails} />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
